import type { AggregatedActivityResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toAggregatedActivity } from './toAggregatedActivity';

// Builds a normalized `Data.AggregatedActivity` domain from a list of DTOs.
// Rows with missing identity or date components are dropped — `toAggregatedActivity`
// returns undefined for those and we guard before mutate-adding so the domain
// only contains entries that can actually be addressed by date + entity.
function toAggregatedActivityDomain(args: {
  dtos: AggregatedActivityResponse[];
}) {
  const { dtos } = args;

  const aggregatedActivityDomain: NormalizedDomain<Data.AggregatedActivity> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const aggregatedActivity = toAggregatedActivity(item);
      if (aggregatedActivity === undefined) return;
      domainUtility.mutateAdd(aggregatedActivityDomain, aggregatedActivity);
    },
  });

  return { aggregatedActivityDomain };
}

export { toAggregatedActivityDomain };
